import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import About from './components/About';
import Testimonials from './components/Testimonials';
import ServiceAreas from './components/ServiceAreas';
import ProcessTimeline from './components/ProcessTimeline';
import MidCTA from './components/MidCTA';
import FAQ from './components/FAQ';
import Gallery from './components/Gallery';
import LeadForm from './components/LeadForm';
import MobileCallButton from './components/MobileCallButton';

export default function HomePage() {
  return (
    <main>
      <Navbar />
      <Hero />
      <TrustBar />
      <Services />
      <WhyChooseUs />
      <About />
      <Testimonials />
      <MidCTA />
      <ServiceAreas />
      <ProcessTimeline />
      <FAQ />
      <Gallery />
      <LeadForm />
      <Footer />
      <MobileCallButton />
    </main>
  );
}
